import { Select } from './select';
import { Options } from '../column';

export class MultiSelect<T = string> extends Select<T> {

    public type = 'multi-select-field';

    public filter = 'multi-select';

    public width = 180;

    /**
     * The typeahead options of the select.
     */
    public data: Array<T> = [];

    constructor(options: Options) {
        super(options);
        this.__construct(options);
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/classes/columns/multi-select.ts